const routerData = [
  /**
   * 会议室管理系统
   */
  {
    path: '/',
    component: () => import('@/pages/meeting-room/index.vue'),
    meta: {
      auth: {
        listType: 'white',
        listData: {
          MeetingRoom: ['Admin', 'Proposer', 'Other']
        }
      }
    },
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/pages/meeting-room/home/home.vue'),
        meta: {
          auth: {
            listType: 'white',
            listData: {
              MeetingRoom: ['Admin', 'Proposer', 'Other']
            }
          }
        }
      },
      {
        path: '/reserve-meeting-room',
        name: 'reserve-meeting-room',
        component: () => import('@/pages/meeting-room/reserve-meeting-room/'),
        meta: {
          auth: {
            listType: 'white',
            listData: {
              MeetingRoom: ['Admin', 'Proposer']
            }
          }
        }
      },
      {
        path: 'my-reserve-meeting-room-list',
        component: () => import('@/pages/meeting-room/my-reserve-meeting-room-list/'),
        meta: {
          auth: {
            listType: 'white',
            listData: {
              MeetingRoom: ['Admin', 'Proposer']
            }
          }
        }
      },
      {
        path: '/all-meeting-rooms',
        component: () => import('@/pages/meeting-room/meeting-rooms/all-meeting-rooms.vue'),
        meta: {
          auth: {
            listType: 'white',
            listData: {
              MeetingRoom: ['Admin']
            }
          }
        }
      },
      {
        path: '/edit-meeting-room',
        name: 'edit-meeting-room',
        component: () => import('@/pages/meeting-room/meeting-rooms/edit-meeting-room.vue'),
        meta: {
          auth: {
            listType: 'white',
            listData: {
              MeetingRoom: ['Admin']
            }
          }
        }
      }
    ]
  },
  // 通知详情
  {
    path: '/',
    component: () => import('@/pages/notice-details/index.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          noticeDetail: []
        }
      }
    }
  },
  // 任务管理
  {
    path: '/',
    component: () => import('@/pages/todo-list/index.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          Todo: []
        }
      },
      keepAlive: false
    },
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'todoHome',
        component: () => import('@/pages/todo-list/home/index.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              Todo: []
            }
          },
          keepAlive: true
        }
      },
      {
        path: '/task-detail',
        component: () => import('@/pages/todo-list/task-detail/index.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              Todo: []
            }
          },
          keepAlive: false
        }
      },
      {
        path: '/add-task',
        component: () => import('@/pages/todo-list/add-task/index.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              Todo: []
            }
          },
          keepAlive: false
        }
      }
    ]
  },
  // 日程安排
  {
    path: '/',
    component: () => import('@/pages/itinerary/index.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          Itinerary: []
        }
      }
    },
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/pages/itinerary/home/index.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              Itinerary: []
            }
          }
        }
      },
      {
        path: '/add-event',
        name: 'addEvent',
        component: () => import('@/pages/itinerary/add-event/index.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              Itinerary: []
            }
          }
        }
      },
      {
        path: '/event-detail',
        name: 'eventDetail',
        component: () => import('@/pages/itinerary/event-detail/index.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              Itinerary: []
            }
          }
        }
      }
    ]
  },
  // 知会人员管理
  {
    path: '/',
    component: () => import('@/pages/zhihui-contacts/index.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          ZhiHuiContacts: []
        }
      }
    },
    redirect: '/contacts-list',
    children: [
      {
        path: '/contacts-list',
        component: () => import('@/pages/zhihui-contacts/contacts-list/index.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              ZhiHuiContacts: []
            }
          }
        }
      },
      {
        path: '/contacts-modify',
        component: () => import('@/pages/zhihui-contacts/contacts-modify/index.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              ZhiHuiContacts: []
            }
          }
        }
      },
      {
        path: '/contacts-version',
        component: () => import('@/pages/zhihui-contacts/contacts-version/index.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              ZhiHuiContacts: []
            }
          }
        }
      },
      {
        path: '/create-contacts-version',
        component: () =>
          import('@/pages/zhihui-contacts/contacts-version/create-contacts-version.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              ZhiHuiContacts: []
            }
          }
        }
      },
      {
        path: '/contacts-modify-notify',
        component: () => import('@/pages/zhihui-contacts/contacts-modify-notify/index.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              ZhiHuiContacts: []
            }
          }
        }
      },
      {
        path: '/modify-person/:id',
        component: () => import('@/pages/zhihui-contacts/contacts-modify/modify-person.vue'),
        meta: {
          auth: {
            listType: 'black',
            listData: {
              ZhiHuiContacts: []
            }
          }
        }
      }
    ]
  },
  // 知会通知管理
  {
    path: '/',
    component: () => import('@/pages/zhihui-notice/index.vue'),
    meta: {
      auth: {
        listType: 'white',
        listData: {
          Notice: ['admin']
        }
      }
    },
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/pages/zhihui-notice/list/sended-notice-list.vue'),
        meta: {
          auth: {
            listType: 'white',
            listData: {
              Notice: ['admin']
            }
          }
        }
      },
      {
        path: '/draft-notice-list',
        component: () => import('@/pages/zhihui-notice/list/sended-notice-list.vue'),
        meta: {
          auth: {
            listType: 'white',
            listData: {
              Notice: ['admin']
            }
          }
        }
      },
      {
        path: '/new-notice',
        component: () => import('@/pages/zhihui-notice/new-notice/new-notice.vue'),
        meta: {
          auth: {
            listType: 'white',
            listData: {
              Notice: ['admin']
            }
          }
        }
      },
      {
        path: '/notice-detail',
        component: () => import('@/pages/zhihui-notice/notice-detail/notice-detail.vue'),
        meta: {
          auth: {
            listType: 'white',
            listData: {
              Notice: ['admin']
            }
          }
        }
      }
    ]
  },
  // 知会用户反馈
  {
    path: '/',
    component: () => import('@/pages/feedback/index.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          Feedback: []
        }
      }
    }
  },
  // 知会用户反馈
  {
    path: '/',
    component: () => import('@/pages/smsNotice/index.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          ZhiHuiSmsNotice: []
        }
      }
    }
  },
  // 清廉监督信息报送系统
  {
    path: '/',
    component: () => import('@/pages/honest-report/index.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          HonestReport: []
        }
      }
    }
  },
  {
    path: '/detail',
    component: () => import('@/pages/honest-report/detail.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          HonestReport: ['reporter']
        }
      }
    }
  },
  // 请假系统
  {
    path: '/',
    component: () => import('@/pages/leave/index.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          LeaveRequest: []
        }
      }
    }
  },
  {
    path: '/application',
    component: () => import('@/pages/leave/application.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          LeaveRequest: []
        }
      }
    }
  },
  {
    path: '/list',
    component: () => import('@/pages/leave/list.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          LeaveRequest: []
        }
      }
    }
  },
  {
    path: '/detail',
    component: () => import('@/pages/leave/detail.vue'),
    meta: {
      auth: {
        listType: 'black',
        listData: {
          LeaveRequest: []
        }
      }
    }
  }
]

export default routerData



// WEBPACK FOOTER //
// ./src/router/appNewRouterData.js